import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div
      style={{
        padding: 'var(--spacing-12)',
        textAlign: 'center',
        background: 'var(--color-surface-muted)',
        border: '1px dashed var(--color-surface-border)',
        borderRadius: 'var(--radius-lg)',
      }}
    >
      <h3 style={{ margin: 0, color: 'var(--color-text-primary)' }}>{title}</h3>
      {description && (
        <p style={{ marginTop: 'var(--spacing-2)', color: 'var(--color-text-secondary)' }}>
          {description}
        </p>
      )}
      {action && <div style={{ marginTop: 'var(--spacing-4)' }}>{action}</div>}
    </div>
  );
}
